import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'
import { requireId } from '@modules/aawz-intelligence-v2/api/guardas'

// ★ A sessão do AVATAR AO VIVO (LiveAvatar LITE) — spec-009, primeiro contato.
//
// Duas chamadas só: abrir e encerrar. O áudio NÃO passa por aqui — ele vai
// do navegador direto ao provedor pelo WebSocket de sessão (`ws_url`), que é
// o que torna a fala do avatar imediata (0,40 s do último chunk ao início da
// fala, medido em 18/09/2026).
//
// ⚠️ **O Modo de Voz não usa este arquivo.** Ele é o GPT-Live
// (`apiVoz.abrirSessaoTempoReal`), e continua exatamente como está.

const MSG_ERRO_ABRIR = (
  'Não foi possível abrir a conversa com o avatar agora. ' +
  'Tente novamente em instantes.'
)
// O encerramento é best-effort de propósito: a sessão do provedor tem teto
// próprio e timeout de ociosidade. Quem fechou a tela já saiu — um erro aqui
// seria aviso sobre algo que se resolve sozinho.
const MSG_ERRO_ENCERRAR = (
  'Não foi possível registrar o fim da conversa com o avatar. ' +
  'Ela encerra sozinha em alguns minutos.'
)

// Prazo da abertura. São DUAS chamadas em série no servidor (criar o token
// e iniciar a sessão) mais uma sala WebRTC nascendo do outro lado. Medido
// em 18/09/2026: ~1,3 s no caso feliz; 30 s dá margem para jitter sem
// deixar a boas-vindas esperando por um rosto que não vem.
const PRAZO_MS_ABERTURA = 30000
const PRAZO_MS_ENCERRAMENTO = 8000

class APIAvatarAoVivo extends APITemplate {
  /**
   * Abre a sessão. Corpo VAZIO de propósito: escritório e profissional vêm
   * da sessão Flask, e não há campo do cliente que possa influenciar uma
   * chamada paga (mesmo desenho da rota de voz em tempo real).
   *
   * @returns {Promise<Object>} `{status, message, value}` — o `value` traz
   *   `{id_sessao, ws_url, livekit_url, livekit_client_token, teto_segundos,
   *   sandbox, avatar_id}`.
   */
  async abrir() {
    const r = await con.post(
      intelligenceV2.avatarAoVivo, {}, false,
      { json: true, timeout: PRAZO_MS_ABERTURA },
    )
    return r || this.buildErrorResponse({ message: MSG_ERRO_ABRIR, value: null })
  }

  /**
   * Encerra a sessão no provedor. Idempotente.
   *
   * @param {Object} opts
   * @param {string} opts.idSessao o id devolvido por `abrir`.
   */
  async encerrar({ idSessao } = {}) {
    const invalido = requireId(idSessao)
    if (invalido) return invalido

    const r = await con.post(
      intelligenceV2.avatarAoVivoEncerrar(idSessao), {}, false,
      { json: true, timeout: PRAZO_MS_ENCERRAMENTO },
    )
    return (
      r || this.buildErrorResponse({ message: MSG_ERRO_ENCERRAR, value: null })
    )
  }
}

const apiAvatarAoVivo = new APIAvatarAoVivo()
export { apiAvatarAoVivo }
